import React from "react";
import { motion } from "framer-motion";
import { Search, Sparkles, Send, LineChart, Bot, Coins } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { TEST_IDS } from "@/constants/testIds";

const ICONS = {
    find: Search,
    enrich: Sparkles,
    engage: Send,
    analyze: LineChart,
    copilot: Bot,
    credits: Coins,
};

export default function Features() {
    const { t } = useI18n();
    return (
        <section id="features" className="relative py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-10">
                <div className="max-w-3xl">
                    <div className="text-xs uppercase tracking-[0.2em] font-bold text-brand-cyan">Modules</div>
                    <h2 className="mt-3 font-display font-black text-4xl sm:text-5xl tracking-tighter text-white">
                        {t.landing.featuresTitle}
                    </h2>
                    <p className="mt-4 text-lg text-zinc-400 max-w-2xl">{t.landing.featuresSub}</p>
                </div>

                <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {t.landing.features.map((f, i) => {
                        const Icon = ICONS[f.key] || Sparkles;
                        return (
                            <motion.div
                                key={f.key}
                                initial={{ opacity: 0, y: 24 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: i * 0.06 }}
                                viewport={{ once: true, margin: "-40px" }}
                                whileHover={{ y: -4 }}
                                data-testid={TEST_IDS.landing.featureCard(f.key)}
                                className="relative p-7 rounded-2xl bg-brand-surface border border-white/5 hover:border-white/15 transition group overflow-hidden"
                            >
                                <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full bg-brand-indigo/20 blur-3xl opacity-0 group-hover:opacity-60 transition-opacity" />
                                <div className="relative">
                                    <div className="flex items-center justify-between">
                                        <div className="w-10 h-10 rounded-lg bg-brand-void border border-white/10 flex items-center justify-center text-brand-cyan">
                                            <Icon size={18} />
                                        </div>
                                        <span className="text-[10px] tracking-[0.2em] uppercase font-bold text-zinc-500">{f.tag}</span>
                                    </div>
                                    <h3 className="mt-6 font-display font-bold text-xl tracking-tight text-white">{f.title}</h3>
                                    <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{f.body}</p>
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
